import { tags } from "./tags/tags.module";
import { modal } from "./modal/modal.module";
import { filter } from "./filter/filter.module";
import { sortgrid } from "./sort-grid/sort-grid.module";
import { bindHtml } from "./bind-html/bind-html.module";
import { searchBar } from "./search-bar/search-bar.module";
import { googleMap } from "./google-map/google-map.module";
import { pagination } from "./pagination/pagination.module";
import { datepicker } from "./datepicker/datepicker.module";
import { breadcrumb } from "./breadcrumb/breadcrumb.module";
import { timepicker } from "./timepicker/timepicker.module";
import { contentCard } from "./content-card/content-card.module";
import { inputNumber } from "./input-number/input-number.module";
import { formButtons } from "./form-buttons/form-buttons.module";
import { intlTelInput } from "./intl-tel-input/intl-tel-input.module";
import { radioTemplate } from "./radio-template/radio-template.module";
import { calendarGridView } from "./calendar/calendar-grid-view.module";
import { googleLocation } from "./google-location/google-location.module";
import { selectDropdown } from "./select-dropdown/select-dropdown.module";
import { repositoryList } from "./repository-list/repository-list.module";
import { uploadCoverPic } from "./upload-cover-pic/upload-cover-pic.module";
import { contentSequence } from "./content-sequence/content-sequence.module";
import { addressTemplate } from "./address-template/address-template.module";
import { displayCoverPic } from "./display-cover-pic/display-cover-pic.module";
import { checkboxTemplate } from "./checkbox-template/checkbox-template.module";
import { pageContentCount } from "./page-content-count/page-content-count.module";
import { featurePermission } from "./feature-permission/feature-permission.module";
import { displayUserOptions } from "./display-users-options/display-options.module";
import { multilevelCheckbox } from "./multilevel-checkbox/multilevel-checkbox.module";
import { mobileCalendarList } from "./calendar-list-mobile-view/calendar-list-mobile-view.module";
import { displayRoundedCoverPic } from "./display-rounded-cover-pic/display-rounded-cover-pic.module";
import { multipleContactTemplate } from "./multiple-contact-template/multiple-contact-template.module";
import copyToClipboard from "./copy-to-clipboard/copy-to-clipboard.module";
import goBack from "./go-back/go-back.module";
import richText from "./rich-text/rich-text.module";
import inputVideoUrlModule from "./input-video-url/input-video-url.module";
import showRemainingCharsModule from "./show-remaining-chars/show-remaining-chars.module";

export const components = angular.module("common.components", [
  multilevelCheckbox,
  checkboxTemplate,
  radioTemplate,
  datepicker,
  sortgrid,
  breadcrumb,
  modal,
  tags,
  searchBar,
  intlTelInput,
  formButtons,
  displayUserOptions,
  calendarGridView,
  mobileCalendarList,
  timepicker,
  addressTemplate,
  googleLocation,
  googleMap,
  uploadCoverPic,
  displayCoverPic,
  selectDropdown,
  featurePermission,
  multipleContactTemplate,
  bindHtml,
  pageContentCount,
  filter,
  pagination,
  contentCard,
  contentSequence,
  inputNumber,
  repositoryList,
  displayRoundedCoverPic,
  copyToClipboard,
  goBack,
  richText,
  inputVideoUrlModule,
  showRemainingCharsModule,
]).name;



// WEBPACK FOOTER //
// ./src/app/common/components/components.module.js